import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setToken } from '../utils/authHelpers';

export default function LoginRedirect() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    // console.log('token param get:', params.get('token'));
    // console.log('token param all:', params.getAll('token'));
    // console.log('access_token get:', params.get('access_token'));
    // console.log('access_token all:', params.getAll('access_token'));

    const token = params.get('token') || params.get('access_token');
    const nextPath = params.get('next') || '/templates';

    if (!token) {
      console.warn("❌ No token found in URL. Redirecting to error page.");
      window.location.href = '/error?reason=missing_token';
      return;
    }

    // console.log("🔑 Received token:", token.slice(0, 16) + '...');
    // console.log("📍 Will redirect to:", nextPath);

    setToken(token);

    const maxRetries = 10;
    let attempts = 0;

    const checkTokenPersisted = () => {
      const storedToken = localStorage.getItem('access_token');

      // console.log(`🕵️ Check #${attempts + 1}:`, storedToken ? 'Token exists' : 'Token missing');

      if (storedToken === token || attempts >= maxRetries) {
        if (storedToken === token) {
          console.log("✅ Token persisted in localStorage. Redirecting now.");
        } else {
          console.warn("⚠️ Max retries reached. Redirecting anyway.");
        }
        window.location.replace(nextPath);
      } else {
        attempts += 1;
        setTimeout(checkTokenPersisted, 150);
      }
    };

    checkTokenPersisted();
  }, [location.search]);

  return (
    <div className="flex items-center justify-center min-h-screen text-gray-700">
      <p className="text-lg">🔁 Logging in…</p>
    </div>
  );
}
